import { useEffect } from "react";

import { withAuditoryCrashlytics } from "../provider/hooks";
import { CAUSED_BY_FRONT, GENERIC_MESSAGE_ERROR } from "../utils/constants";

const RegisterCrashlytics = () => {
  useEffect(() => {
    const handleErrors = (err) => {
      const code = CAUSED_BY_FRONT;
      const message = err.error?.message || err.message || err.error;
      const stack = err.error?.stack;

      if (
        !err.error?.stack?.includes("nrWrapper") &&
        !GENERIC_MESSAGE_ERROR.includes(message)
      ) {
        withAuditoryCrashlytics({
          code,
          message,
          stack,
          error: err.error,
        });
      }
    };

    window.addEventListener("error", handleErrors);
    return () => {
      window.removeEventListener("error", handleErrors);
    };
  }, []);

  return null;
};

export default RegisterCrashlytics;
